module.exports = __webpack_public_path__ + "static/img/sou-w@2x.af474c6b.png";